import React, { useEffect, useState } from 'react';
import { checkElement } from '@/components/SubSectionComponents/CleanFunctions.jsx';
import img from '@/assets/img/AncrageImgs/firstPx/PX+PX+PX_Maxi.svg';
import S from '@/styles/reactImgsBallast.module.css';
import InfoT from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoT.jsx';
import InfoD from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoD.jsx';
import ConfigStabilizeInfoButton from '@/pages/formwork/boxes/ConfiguratorStabilizier/ConfigStabilizeInfoButton.jsx';
import InfoB from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoB.jsx';

function PxPxPxMax({ allHeightsPanel, T, D, B, fixTop }) {
  const [find, setFind] = useState(false);

  useEffect(() => {
    if (allHeightsPanel.length === 3 && checkElement.allPanels(allHeightsPanel) && fixTop) {
      setFind(true);
    } else setFind(false);
  }, [allHeightsPanel, fixTop]);

  if (!find) {
    return null;
  }

  return (
    <div className={S.container}>
      <img className={S.containerImg} src={img} alt={'3m'} style={{ top: 0, left: -20 }} />
      <InfoT top={310} left={162} T={T} />
      <InfoD top={522} left={127} D={D} />
      <InfoB top={464} left={154} B={B} />
      <ConfigStabilizeInfoButton top={10} />
    </div>
  );
}

export default PxPxPxMax;
